<template>
  <div class="token-search-bar">
    <vue-autosuggest
      ref="autocomplete"
      v-model="query"
      :suggestions="suggestions"
      :input-props="inputProps"
      :render-suggestion="renderSuggestion"
      @input="fetchResults"
      @selected="selectHandler"
      :get-suggestion-value="getSuggestionValue"
    >
    </vue-autosuggest>

    <div
      v-if="loading"
      class="token-search-bar loading-container d-flex justify-content-center ma-1"
    >
      <b-spinner type="grow" label="Loading..." />
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
/* eslint no-unused-expressions: ["error", { "allowShortCircuit": true }] */
import {
  BCard,
  BCardText,
  BAvatar,
  BMedia,
  BRow,
  BCol,
  BSpinner
} from "bootstrap-vue";
import { VueAutosuggest } from "vue-autosuggest";
import axios from "axios";
import {
  truncateString,
  formatCurrency,
  formatNumber,
  subStringGenerator,
  formatDate
} from "../../filters";

export default {
  components: {
    VueAutosuggest,
    BCard,
    BCardText,
    BAvatar,
    BMedia,
    BRow,
    BCol,
    BSpinner
  },
  data() {
    return {
      query: "",
      results: [],
      timeout: null,
      selected: null,
      debounceMilliseconds: 250,
      usersUrl: "https://jsonplaceholder.typicode.com/users",
      photosUrl: "https://jsonplaceholder.typicode.com/photos",
      inputProps: {
        id: "autosuggest__input_ajax",
        placeholder: "Please enter the token address to search",
        class: "form-control",
        name: "ajax"
      },
      loading: false,
      suggestions: []
    };
  },
  filters: {
    truncateString,
    formatCurrency,
    formatNumber,
    subStringGenerator,
    formatDate
  },
  methods: {
    fetchResults() {
      const { query } = this;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        //check for valid token address
        const isTokenAddressValid = this.validatedTokenAddress(query);
        if (isTokenAddressValid) {
          try {
            this.loading = true;
            const endpoint =
              process.env.VUE_APP_BASE_URL_APE +
              "contract-events/token-search/" +
              query;
            const suggestionList = [];
            const response = await axios.get(endpoint);
            const tokenData = response.data.payload;
            suggestionList.push(tokenData);
            this.suggestions = [{ data: suggestionList }];
          } catch (error) {
            console.error(
              "Something went wrong while fetching token data",
              error.message || error
            );
          } finally {
            this.loading = false;
          }
        }
      }, this.debounceMilliseconds);
    },
    validatedTokenAddress(tokenAddress) {
      if (tokenAddress && tokenAddress.length == 42) {
        return true;
      } else {
        return false;
      }
    },
    renderSuggestion(suggestion) {
      const { item } = suggestion;
      if (item) {
        return (
          <span class="click-pointer search-result-row d-flex">
            <div class="token-data-avatar">
              <b-avatar size="32" text="A" class="token-pair-avatar" />
            </div>
            <div class="token-data-container">
              <div class="token-main-address">
                <small class="token-address">
                  {truncateString(item.tokenAddress, 12)}
                </small>
              </div>
              <div class="token-sub-data">
                <small class="token-address">
                  {item.tokenSymbol} - {item.tokenName}
                </small>
              </div>
            </div>
          </span>
        );
      } else {
        return (
          <div class="d-flex">
            <div class="no-result">
              No results found please check the token address
            </div>
          </div>
        );
      }
    },
    getSuggestionValue(suggestion) {
      const { item } = suggestion;
      return item.tokenAddress;
    },
    selectHandler(selectedItem) {
      const { item } = selectedItem;
      this.$router.push({
        path: `/details/${item.tokenAddress}`,
        params: {
          id: item.tokenAddress
        }
      });
    }
  }
};
</script>

<style lang="scss">
.token-search-bar {
  margin: 10px 0px;
}

.autosuggest__results ul {
  padding: 10px 5px;
  list-style-type: none !important;
  margin: 3px;
  border-radius: 10px;
  border: 1px solid #283046;
}

.search-result-row .token-data-avatar {
  margin-right: 10px;
}
</style>
